module.exports = __webpack_public_path__ + "img/9788963572048.7558893f.jpg";